let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jLkRH")).then(() => parcelRequire('195GW'));